import { createContext, useState, useContext } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  const triggerLoginPopup = (value) => {
    setShowLoginPopup(value);
}

  return (
    <AuthContext.Provider
      value={{ showLoginPopup, triggerLoginPopup }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
